const style = {
  pageContainer: {
    width: "100%",
    maxWidth: "900px",
    margin: "0 auto",
    backgroundColor: "#161B22",
    borderRadius: "16px",
    border: "1px solid #30363D",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
    display: "flex",
    flexDirection: "column",
    marginBottom: '40px',
  },
  pageHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #30363D",
    padding: "24px 30px",
  },
  headerInfo: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  enterpriseName: {
    fontSize: "22px",
    fontWeight: "600",
    color: "#E6EDF3",
    margin: 0,
  },
  enterpriseCnpj: {
    fontSize: "14px",
    color: "#8B949E",
    margin: "4px 0 0 0",
  },
  backButton: {
    background: "transparent",
    border: "1px solid #30363D",
    color: "#8B949E",
    fontSize: "14px",
    cursor: "pointer",
    padding: "8px 16px",
    borderRadius: "6px",
  },
  pageBody: {
    padding: "0 30px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "30px",
  },
  infoColumn: {},
  subscriptionColumn: {},
  infoBlock: {
    marginTop: "24px",
  },
  infoTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#8B949E",
    margin: "0 0 12px 0",
    textTransform: "uppercase",
  },
  infoText: {
    fontSize: "14px",
    color: "#C9D1D9",
    margin: "0 0 8px 0",
    lineHeight: "1.6",
  },
  subscriptionCard: {
    backgroundColor: "rgba(13, 17, 23, 0.5)",
    borderRadius: "8px",
    border: "1px solid #30363D",
    padding: "16px",
  },
  subscriptionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  subscriptionPlan: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#E6EDF3",
    margin: 0,
  },
  statusBadge: {
    padding: "4px 10px",
    borderRadius: "9999px",
    fontSize: "11px",
    fontWeight: "600",
  },
  statusActive: {
    backgroundColor: "rgba(4, 120, 87, 0.3)",
    color: "#34D399",
  },
  statusPending: {
    backgroundColor: "rgba(217, 119, 6, 0.3)",
    color: "#FBBF24",
  },
  statusBlocked: {
    backgroundColor: "rgba(153, 27, 27, 0.3)",
    color: "#F87171",
  },
  inputLabel: {
    fontSize: "12px",
    color: "#8B949E",
    marginBottom: "4px",
    display: "block",
  },
  input: {
    width: "100%",
    backgroundColor: "#0D1117",
    border: "1px solid #30363D",
    borderRadius: "6px",
    color: "#E6EDF3",
    padding: "8px 12px",
    fontSize: "14px",
    marginBottom: "12px",
    boxSizing: "border-box",
  },
  pageFooter: {
    borderTop: "1px solid #30363D",
    padding: "16px 30px",
    display: "flex",
    justifyContent: "flex-end",
  },
  buttonContainer: {
    display: "flex",
    gap: "12px",
  },
  actionButton: {
    border: "1px solid #30363D",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.2s, color 0.2s, border-color 0.2s",
    backgroundColor: "transparent",
    color: '#8B949E',
  },
  editButton: {
    backgroundColor: "#238636",
    color: "#ffffff",
    border: "1px solid #238636"
  },
  saveButton: {
    backgroundColor: "#388BFD",
    color: "#ffffff",
    border: "1px solid #388BFD"
  },
  cancelButton: {
    backgroundColor: "transparent",
    color: "#8B949E",
    border: "1px solid #30363D",
  },
  mainSection: {
    gridColumn: '1 / -1',
    padding: '0 30px 24px 30px',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    borderTop: '1px solid #30363D',
    paddingTop: '24px'
  },
  addButton: {
    backgroundColor: '#238636',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 16px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'opacity 0.2s ease',
  },
  'addButton:disabled': {
    backgroundColor: '#2b3137',
    color: '#8B949E',
    cursor: 'not-allowed',
    opacity: 0.6,
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  card: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'rgba(13, 17, 23, 0.5)',
    padding: '12px 16px',
    borderRadius: '8px',
    border: '1px solid #30363D'
  },
  cardInfo: {},
  cardName: {
    margin: 0,
    fontSize: '15px',
    fontWeight: '600',
    color: '#C9D1D9'
  },
  cardSubtext: {
    margin: '4px 0 0 0',
    fontSize: '12px',
    color: '#8B949E',
  },
  cardActions: {
    display: 'flex',
    gap: '10px'
  },
  deleteButton: {
    color: '#F87171',
  },
  noItemsText: {
    textAlign: 'center',
    color: '#8B949E',
    padding: '20px',
    fontSize: '14px',
  }
};

export default style;